import { InstanceParams } from "charts/src/types/chart";

export const validateCustomPortfolioInstanceParams = ({
  instanceParams,
}: {
  instanceParams: InstanceParams;
}) => "portfolioId" in instanceParams && !!instanceParams.portfolioId;
